import { ADD_TO_CART_ERROR, ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, CART_QUANTITY_CHANGED, DECAL_EDITOR_SETTINGS_LOAD_ERROR, DECAL_EDITOR_SETTINGS_RECEIVE, LOAD_SIGN_FOR_EDIT_REQUEST, LOAD_SIGN_FOR_EDIT_SUCCESS, LOAD_SIGN_FOR_EDIT_ERROR, CANCEL_SIGN_EDITING, UPLOADED_IMAGES, CART_IMAGES, LOAD_EDITOR_TEMPLATE_SUCCESS, EDITOR_TEMPLATE_MODIFIED, } from '../../Rutab/RutabConstants';
const initialState = {
    settings: null,
    loadingSettings: false,
    settingsError: null,
    addingToCart: false,
    cartError: null,
    cartResult: null,
    cartQuantity: 1,
    loadingSignForEdit: false,
    signForEdit: null,
    signForEditError: null,
    uploadedImages: [],
    cartImages: [],
    productTemplate: null,
    productTemplateModified: false,
};
export const decalEditorAPI = (state = initialState, action) => {
    switch (action.type) {
        case DECAL_EDITOR_SETTINGS_RECEIVE:
            return Object.assign(Object.assign({}, state), { settings: action.payload.settings, loadingSettings: false, settingsError: null });
        case DECAL_EDITOR_SETTINGS_LOAD_ERROR:
            return Object.assign(Object.assign({}, state), { loadingSettings: false, settingsError: action.payload.error });
        case ADD_TO_CART_REQUEST:
            return Object.assign(Object.assign({}, state), { addingToCart: true, cartError: null });
        case ADD_TO_CART_SUCCESS:
            return Object.assign(Object.assign({}, state), { addingToCart: false, cartResult: action.payload.result, cartError: null, signForEditError: null, signForEdit: null, uploadedImages: [], cartQuantity: 1 });
        case ADD_TO_CART_ERROR:
            return Object.assign(Object.assign({}, state), { addingToCart: false, cartError: action.payload.error });
        case CART_QUANTITY_CHANGED:
            return Object.assign(Object.assign({}, state), { cartQuantity: action.payload.cartQuantity });
        case LOAD_SIGN_FOR_EDIT_REQUEST:
            return Object.assign(Object.assign({}, state), { loadingSignForEdit: action.payload.isLoading, signForEditError: null });
        case LOAD_SIGN_FOR_EDIT_SUCCESS:
            return Object.assign(Object.assign({}, state), { signForEdit: action.payload.sign, signForEditError: null });
        case LOAD_SIGN_FOR_EDIT_ERROR:
            return Object.assign(Object.assign({}, state), { loadingSignForEdit: false, signForEditError: action.payload.error });
        case CANCEL_SIGN_EDITING:
            return Object.assign(Object.assign({}, state), { loadingSignForEdit: false, signForEdit: null, signForEditError: null, cartQuantity: 1, uploadedImages: [] });
        case UPLOADED_IMAGES:
            return Object.assign(Object.assign({}, state), { uploadedImages: action.payload.uploadedImages });
        case CART_IMAGES:
            return Object.assign(Object.assign({}, state), { cartImages: action.payload.images });
        case LOAD_EDITOR_TEMPLATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { productTemplate: action.payload.template, productTemplateModified: false });
        case EDITOR_TEMPLATE_MODIFIED:
            return Object.assign(Object.assign({}, state), { productTemplateModified: true });
        default:
            return state;
    }
};
